import React, { useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Card, CardBody, Col } from 'reactstrap';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false, // hide default legend
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      enabled: true,
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: false, // ❌ remove vertical grid lines
        drawBorder: false,
      },
    },
    y: {
      stacked: true,
      beginAtZero: true,
      grid: {
        display: false, // ❌ remove horizontal grid lines
        drawBorder: false,
      },
    },
  },
};

const DelayedBookingChart = ({ title, data }) => {
  // Prevent rendering until data is fully available
  if (!data || !data.dates || !Array.isArray(data.categories)) {
    return null; // or return a loader/spinner if you want
  }

  const chartData = {
    labels: data.dates,
    datasets: data.categories.map(category => ({
      label: category.label,
      data: category.data,
      backgroundColor: category.color,
      stack: 'stack1',
    })),
  };

  const [selectedItems, setSelectedItems] = useState(chartData.datasets.map(ds => ({ name: ds.label, color: ds.backgroundColor })));

  const toggleLegend = item => {
    setSelectedItems(prev => {
      const isRemoved = prev.some(d => d.name === item.name);
      return isRemoved ? prev.filter(d => d.name !== item.name) : [...prev, item];
    });
  };

  const filteredChartData = {
    labels: chartData.labels,
    datasets: chartData.datasets.filter(ds => selectedItems.some(item => item.name === ds.label)),
  };

  return (
    <Col xs="12" className="mb-2" style={{ borderRadius: '10px' }}>
      <Card>
        <div className="d-flex justify-content-between m-4">
          <h4 className="card-title mb-0 flex-grow-1 fw-semibold">{title}</h4>
        </div>

        <CardBody style={{ position: 'relative', width: '100%', height: '350px' }}>
          <Bar data={filteredChartData} options={chartOptions} />
        </CardBody>

        {/* ✅ Custom Legend */}
        <div className="d-flex flex-wrap justify-content-center mt-3 mb-3">
          {chartData.datasets.map(item => {
            const isSelected = selectedItems.some(d => d.name === item.label);
            return (
              <div
                key={item.label}
                onClick={() => toggleLegend({ name: item.label, color: item.backgroundColor })}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '3px',
                  padding: '5px 10px',
                  backgroundColor: '#F2F2F7',
                  color: 'black',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                <div
                  style={{
                    width: '13px',
                    height: '13px',
                    backgroundColor: item.backgroundColor,
                    borderRadius: '3px',
                    marginRight: '8px',
                    border: '1px solid #ccc',
                  }}
                ></div>
                <span
                  style={{
                    textDecoration: !isSelected ? 'line-through' : 'none',
                    fontWeight: '400',
                    fontSize: 12,
                  }}
                >
                  {item.label}
                </span>
              </div>
            );
          })}
        </div>
      </Card>
    </Col>
  );
};

export default DelayedBookingChart;
